import { Button, FormControl, Grid, InputLabel, MenuItem, Paper, Select, TextField } from "@material-ui/core";
import {
    createStyles, makeStyles,
    Theme
} from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import Api from "../../../../helpers/api";
import {
    getProjects, PostCloseProject, uploadMediaFiles
} from "../../store/actions";
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        table: {
            minWidth: 700,
        },
        hoveItem: {
            cursor: "pointer",
        },

        input: {
            padding: "1px",
        },
    })
);
interface Props {
    billings: any;
    onBoardingActionType: any;
    getProjects: any;
    projects: any;
    uploadMediaFiles: any;
    mediaUpload: any;
    PostCloseProject: any;

}
const StopsPlace: React.FC<Props> = ({
    billings,
    onBoardingActionType,
    getProjects,
    projects,
    uploadMediaFiles,
    mediaUpload,
    PostCloseProject,

}) => {
    const classes = useStyles();
    const history = useHistory();
    const timer = useRef<any>(0);
    const [billingComplete, setBillingComplete] = useState<any>("");
    const [isEdit, setIsEdit] = useState<any>(false);
    const { id } = useParams<{ id: string }>();
    const [billingDate, setBillingDate] = useState<any>("");
    const [displayProject, setDisplayProject] = useState<string>("");
    const [project, setProject] = useState<any>(null);
    const [uploading, setUploading] = useState<boolean>(false);
    const [comment, setComment] = useState<any>("");
    const fileSelectedHandler = async (e: React.ChangeEvent<{ files: any }>, type: any) => {
        const formData = new FormData();
        formData.append("file", e.target.files[0]);
        setUploading(true);
        Api.post("/media", formData).then((data: any) => {
            setMediaFile({
                ...mediaFile,
                [type]: data?.path,
            })
            setUploading(false);
        }).catch(() => {
            setUploading(false);
        });
    };
    const [mediaFile, setMediaFile] = useState<any>({
        "billingFile": "",
    }
    );
    const handleBillingData = async (e: any) => {
        e.preventDefault();
        const filterPath = mediaFile
        const closeProjectData = {
            billingDate: billingDate,
            billingFile: filterPath?.billingFile,
            billingCompleted: billingComplete,
            comment: comment,

        };
        await PostCloseProject(closeProjectData, project);

        history.push(`/dashboard/gnrelab/ProjectCloser`);

    };
    useEffect(() => {
        getProjects(id);

    }, [])

    useEffect(() => {
        if (projects) {
            const BillingsData = projects;
            setDisplayProject(BillingsData?.projectId)
            setProject(BillingsData?._id)
            setComment(BillingsData?.comment)

        }
    }, [projects]);
    
    return (
        <form onSubmit={handleBillingData} style={{ width: "100%" }}>
            <Paper style={{ margin: "70px auto", width: "80%", background: "#eff", marginTop: 60 }}>
                <h2 style={{ fontWeight: "bold", paddingTop: "20px", paddingBottom: "10px", textAlign: "center" }}>Billings & Project Closed </h2>
                <Grid
                    container
                    direction="row"
                    justify="space-between"
                    alignItems="flex-end"
                    spacing={2}
                    style={{ margin: "1rem auto" }}
                >
                    <Grid item xs={12} sm={3}>
                        <Autocomplete
                            id="Project_id"
                            onChange={(event, newValue) => {
                                setProject(newValue?._id);
                            }}
                            defaultValue={projects?.projectId}
                            options={projects?.results || []}
                            inputValue={displayProject}
                            blurOnSelect
                            getOptionLabel={(option: any) => {
                                return (
                                    (option?.projectId) +
                                    " " +
                                    (option?.institute?.name || "") +
                                    " " +
                                    (option?.scientist?.name || "") +
                                    "," +
                                    (option?.dealer?.firmName || "")
                                );
                            }}
                            onInputChange={(event, newInputValue) => {
                                let data = newInputValue.split(" ");
                                clearTimeout(timer.current);
                                timer.current = setTimeout(() => {
                                    if (data.length > 0) {
                                        getProjects(`?projectId=${data[0]}`);
                                    }
                                }, 1000);
                                setDisplayProject(newInputValue)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    className="input"
                                    label="Project Id"
                                    placeholder="Search ID/Client/Dealer Name"
                                    variant="outlined"
                                    fullWidth
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3} >
                        <TextField
                            label="Billing Date"
                            variant="outlined"
                            className="input"
                            type="date"
                            fullWidth
                            value={billingDate}
                            onChange={(e) => setBillingDate(e.target.value)}
                            inputProps={{
                                max: moment().format("YYYY-MM-DD"),
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormControl style={{ width: "100%" }} className="input">
                            <InputLabel>Billing Completed</InputLabel>
                            <Select
                                label="Raw Data Sharing Mode"
                                variant="outlined"
                                className="input"
                                fullWidth
                                value={billingComplete || "none"}
                                style={{ width: "100%", height: "40px" }}
                                onChange={(e) => setBillingComplete(e.target.value)}
                            >
                                <MenuItem value="none"><em>Select Billing Status</em></MenuItem>
                                <MenuItem value="yes">Yes</MenuItem>
                                <MenuItem value="no">No</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                        <TextField
                            id="filled-number"
                            className="input"
                            label="Comments"
                            fullWidth
                            value={comment}
                            placeholder="type Comments"
                            variant="outlined"
                            onChange={(e) => setComment(e.target.value)}

                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <sup
                            style={{
                                fontSize: "11px",
                                marginLeft: "15px",
                                marginTop: "15px",
                                background: "#fff",
                                color: "rgba(0, 0, 0, 0.54)",
                                letterSpacing: "0.00938em",
                            }}
                        >
                            Upload Pdf
                        </sup>
                        <input
                            className={classes.input}
                            style={{
                                width: "100%",
                                height: "46px",
                                marginTop: "-15px",
                                padding: "11.5px 14px",
                                border: "1px solid rgba(0, 0, 0, 0.23)",
                                borderRadius: "5px",
                            }}
                            type="file"
                            name="file"
                            id="file"
                            multiple
                            onChange={(e: any) => fileSelectedHandler(e, "billingFile")}

                        />
                    </Grid>
                </Grid>

                <Grid xs={6} style={{ textAlign: "center", padding: "20px" }}>
                    <Button
                        color="primary"
                        variant="contained"
                        type="submit"
                        style={{ width: 300 }}
                        disabled={uploading}

                    >
                        {isEdit ? "update" : "Close Project"}
                    </Button>
                </Grid>
            </Paper>
        </form>
    );
};
const mapStateToProps = (state: any) => ({
    projects: state.GenomicsLabReducer.projects,
    mediaUpload: state.GenomicsLabReducer.mediaUpload,

});
export default connect(mapStateToProps, {
    getProjects,
    uploadMediaFiles,
    PostCloseProject,
})(StopsPlace);
